import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Injectable()
export class LoggedInGuard  {

    constructor(
        private router: Router,
        public authService: AuthService
    ) {}

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        return new Promise((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                resolve(true);
            }).catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true });
                reject(false);
            });
        });
    }
}
